import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../withRouter.js";
import { theme, userid } from "../Common/Credentials";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import Menu from "../Component/Menu";
import MailTempletes from "./MailTempletes";
import MailConfig from "./MailConfig";
import UpArrow from "../images/Icons/up-arrow.png";
import Breadcrumb from "../NewUI/NewComponents/Breadcrumb.jsx";
import Layout from "../Component/Layout.jsx";
import TabSwitch from "../NewUI/NewComponents/TabSwitch.jsx";

class MailSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      i: 0,
      mailOptions: [{ value: 0, label: "Mail Configuration" }, { value: 1, label: "Templates" }],
      mselected: 0,
    };
  }
  monChange(option) {
    this.setState({ mselected: option.value });
  }

  componentDidMount() {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Login back to Resume");
      this.props.navigate(`/`);
    }
  }
  render() {
    return (
      <div>
        <Layout menu={"settings"}>
          <div className="tw-ml-2">
            <div className="card card-info">
              <div className="UI-header">
                <Breadcrumb breadcrumbs={[{ name: "Home", path: "/index" }, { name: "Settings", path: "/settings" }, { name: "Mail Settings", path: null }]} />
              </div>
              {/* <ol className="breadcrumb float-sm-right">
              <li className="breadcrumb-item text-secondary">
                <Link to="/index">Home</Link>
              </li>
              <li className="breadcrumb-item text-secondary">
                <Link to="/settings">Settings</Link>
              </li>
              <li className="breadcrumb-item active">Mail Settings</li>
            </ol> */}

              {/* <div className="card"> */}
              {/* <div className="card-header">
                <h3 className="card-title text-secondary">
                  <i className="fas fa-cog mr-2 textColour"></i>
                  Mail Settings / {this.state.mselected === 0?"Mail Configuration":"Templets"} 
                </h3>
              </div> */}
              <div className="p-4">

                <div className="form row">

                  <div className="d-flex gap-2 m-2">

                    <TabSwitch options={this.state.mailOptions} value={this.state.mselected} onChange={(option) => this.setState({ mselected: option })} activeTabClass={theme === "modern" ? "tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600 tw-text-white tw-py-1" : "!tw-bg-[#4d4d4d] tw-text-white tw-py-1"} />
                    {/* {this.state.mailOptions.map((option) => (
                      <fieldset
                                  key={option.id}
                        className={`tab-button mr-2 ${this.state.mselected === option.id ? 'active-tab' : 'inactive-tab'}`}
                        onClick={() => this.setState({ mselected: option.id })}
                      >
                        {option.name}
                        <img
                          src={UpArrow}
                          alt="Up Arrow"
                          style={{
                            marginLeft: "4px",
                            width: "1.5rem",
                            height: "1.5rem",
                            padding: "4px",
                            transform: "rotate(30deg)",
                          }}
                        />
                      </fieldset>
                    ))} */}
                  </div>

                  <div className="col-md-12"></div>
                  {this.state.mselected === 0 ?
                    <div className="col-md-12"><MailConfig /></div>
                    :
                    <div className="col-md-12"><MailTempletes /></div>
                  }
                </div>
              </div>
              {/* </div> */}
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}
export default withRouter(MailSettings);
